import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import styles from "./styles.module.scss";

const Modal = ({
  isOpen,
  onClose,
  children,
  header,
  size,
  notCentered,
  withAlert,
  headingCentered,
  headingCenteredSpaced,
  customClass = "",
}) => {
  const [isClosing, setIsClosing] = useState(false);
  const [shouldRender, setShouldRender] = useState(isOpen);
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      document.body.style.overflow = "unset";
    };
  }, []);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      document.body.style.overflow = "hidden";
    } else {
      setIsClosing(true);
      const timer = setTimeout(() => {
        if (isMounted.current) {
          setIsClosing(false);
          setShouldRender(false);
          document.body.style.overflow = "auto";
        }
      }, 300);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [isOpen]);

  if (!shouldRender) return null;

  return ReactDOM.createPortal(
    <div
      className={`${styles.modalOverlay} ${isClosing ? styles.fadeOut : styles.fadeIn} ${notCentered ? styles.notCentered : ""} ${withAlert ? styles.withAlert : ""}  ${customClass ? customClass : ""}`}
      onClick={onClose}
    >
      <div
        className={`${styles.modalContent} ${isClosing ? styles.close : styles.open} ${size ? styles[size] : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        {header && (
          <div
            className={`${styles.modalHeader} ${headingCentered ? styles.headingCentered : ""} ${headingCenteredSpaced ? styles.headingCenteredSpaced : ""}`}
          >
            {header}
          </div>
        )}
        <button className={styles.closeButton} onClick={onClose}>
          &times;
        </button>
        <div className={styles.modalBody}>{children}</div>
      </div>
    </div>,
    document.body,
  );
};

export default Modal;
